import React from 'react'
import { useMediaQuery } from '@mui/material'

import AvatarArea from '../../../BaseConversation/AvatarArea'
import Content from '../../../BaseConversation/Content'
import Button from '../../../../atoms/Button'

import { hydrateMessage } from '../../../../../utilities'
import { useEnvironment } from '../../../../../providers/EnvironmentProvider'
import useStyles from './styles'

const GroupChat = ({ chat, onSelect, onLeave }) => {
  const onSmallerScreen = useMediaQuery('(max-width: 500px)')

  const { user } = useEnvironment()

  const [intersect, setIntersect] = React.useState(null)
  const [element, setElement] = React.useState(null)

  const classes = useStyles()

  const {
    name,
    userIds: users,
    id: session,
    latest_activity: latestActivity,
    converted
  } = chat

  const lastMessage = React.useMemo(() => {
    const latest = latestActivity[0]
    if (converted) {
      return latest
    }
    try {
      return hydrateMessage(latest)
    } catch (err) {
      console.error('Error hydrating', { err, latest })
      return null
    }
  }, [latestActivity, converted])

  const contentProps = {
    name,
    selected: false,
    lastMessage,
    isNew: false,
    typingNames: [],
    numUsers: users?.length ?? 0,
    handleCloseConversation: () => { },
    users,
    session,
    isYours: true,
    messages: [
      ...(Array.isArray(latestActivity) ? latestActivity : [latestActivity])
    ].sort((a, b) => new Date(b) - new Date(a)),
    conversation: chat
  }

  // observer variable to set viewport and check if user is in it
  const observer = React.useRef(
    new IntersectionObserver(
      entries => {
        setIntersect(entries[0])
      },
      { root: document.querySelector('#conversations'), threshold: 0 }
    )
  )

  // effect for watching and unwatching observer variable
  React.useEffect(() => {
    const currentElement = element
    const currentObserver = observer?.current

    if (currentElement) {
      currentObserver.observe(currentElement)
    }

    // clean up observer to stop watching
    return () => {
      if (currentElement) {
        currentObserver.unobserve(currentElement)
      }
    }
  }, [element])

  return (
    <div ref={setElement} className={classes.root}>
      <div className={classes.contentArea} onClick={onSelect}>
        {!onSmallerScreen && (
          <AvatarArea
            userIDs={chat.userIds.filter(id => id !== user?.id)}
            intersect={intersect}
          />
        )}

        <Content {...contentProps} className={classes.content} />

        <Button onClick={(e) => { e.stopPropagation(); e.preventDefault(); onLeave() }} className={classes.button}>
          Leave
        </Button>
      </div>
    </div>
  )
}

export default GroupChat
